import React, { useState } from "react";
import {
  selectLocationsByState,
  useGetLocationsQuery,
} from "../features/rapidstor/rapidstorApiSlice";
import { useSelector } from "react-redux";
import LocationCard from "./LocationCard";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import classes from "./LocationCard.module.scss";
import Card from "react-bootstrap/Card";

function LocationSelector() {
  const { isLoading, error, refetch } = useGetLocationsQuery();
  const [region] = useState<string>("");
  const locations = useSelector((state) => selectLocationsByState(state, region));

  let content;

  if (isLoading && locations.length === 0) {
    content = <Col>Loading locations...</Col>;
  } else if (error) {
    content = (
      <Col>
        <Alert>
          Sorry, we were unable to load the list of facilities.
          <div className={"mt-2"}>
            <Button onClick={refetch}>Retry</Button>
          </div>
        </Alert>
      </Col>
    );
  } else if (locations.length === 0) {
    content = (
      <Col lg={6}>
        <Card className={`${classes.card} ${classes.expanded}`}>
          <Card.Body className={classes.cardBody}>
            <div className={classes.facilityInfo}></div>
          </Card.Body>
        </Card>
      </Col>
    );
  } else {
    content = locations.map((location) => (
      <Col lg={6} key={location.locationCode}>
        <Link to={`/${location.slug}`} className="hidden-link">
          <LocationCard locationCode={location.locationCode} />
        </Link>
      </Col>
    ));
  }

  return (
    <>
      <Row>{content}</Row>
    </>
  );
}

export default LocationSelector;
